import React from "react";
import "../App.css"
import team1 from "../images/team-1.png"
import team2 from "../images/team-2.png"
import team3 from "../images/team-3.png"
import team4 from "../images/team-4.png"
import twitter from "../images/icon-twitter.png"
import insta from "../images/icon-insta.png"
import Footer from "./Footer";
import Res1 from '../images/Res1.jpeg'
import Res2 from '../images/Res2.jpeg'


function OurTeam() {
    return (
        <div className="ourteamBg">
            <div className="container">
                <div className="row" id="team">
                    <div className="col-md-12  pt-4 ourTeam text-center">
                        <h2 className="pb-4">Our Team</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 ourTeam">
                        <p className="">led by Darthsinvader, comprised of experts in all aspects of the NFT space,
                            including entrepreneurship, community building, top-level restaurant ownership in the US,
                            and extensive crypto expertise. We are committed to creating the most exceptional utility
                            in the NFT space, offering unique benefits to our community members.
                        </p>
                        <p>By surrounding yourself with the most successful individuals in the industry, you will position
                            yourself to learn, succeed, make money, and, above all, be part of a family that goes beyond
                            the markets and NFTs. Our community provides a platform for making lifelong connections and
                            friendships, where members can thrive together and achieve their goals.</p>
                    </div>
                </div>

                <div className="row pt-5 pb-5">
                    <div className="col-md-3">
                        <div className="ceo text-left">
                            <img className="ourteamsetting-img1" src={team1}></img>
                            <p className="name pt-5">DarhthsInvader</p>
                            <p className="aboutTeamMember">- is the owner of 5 overly successful restaurants in NY and is the
                                creator of 2 NFT collections as well as his own released "bored and dirty" beer. Both of those
                                collections are deeply tied to Darth’s business IRL. DarthsInvader is known for giving undeniably
                                insane utility/benefits to his customers and providing great incentives within his community.</p>

                            {/* <div className="resImageStyle">
                                <img className="resImage" src={Res1}></img>
                                <img className="resImage" src={Res2}></img>
                            </div> */}

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="developer text-left">
                            <img className="w-100 ourteamsetting-img" src={team2}></img>
                            <p className="name pt-5">Wolf</p>
                            <p className="aboutTeamMember ">- Has worked with darthsinvader for over 7 years. They built their
                                friendship while professionally competing in FIFA E-sports and has built brands and Ideas together
                                since. He works tirelessly around the clock creating ideas, brands, discord innovations and consults
                                many other projects.</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="designer text-left">
                            <img className="w-100 ourteamsetting-img" src={team3}></img>
                            <p className="name pt-5">Tomiwa</p>
                            <p className="aboutTeamMember">- An exceptional artist/writer from Nigeria who has worked professionally
                                as an illustrator for the last 5 years with indie comic groups and individuals. His style is a blend of
                                western and eastern influences and has no limits or artistic boundaries.</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="marketing text-left">
                            <img className="w-100 ourteamsetting-img" src={team4}></img>
                            <p className="name pt-5">ASquare</p>
                            <p className="aboutTeamMember">- Genius coder who has been with DARTHSINVADER from the start. Creates and
                                develops innovative contracts. NFT/Web3 Developer, creating opportunities by providing #blockchain solutions
                                to the world.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 pb-5 projectDes">
                        <p> At Project Artaxia, we believe that our community members are at the heart of everything we do.
                            That’s why we are committed to putting our users first, listening to their feedback, and continuously
                            improving our offerings to provide exceptional value.</p>
                        <p>We are committed to ensuring that the initial funding collected is used towards creating more value
                            for our community members. We prioritize transparency in all aspects of our operations, from funding
                            allocation to project development and beyond.</p>
                        <p>With our sister project already paid for and completed, we have the freedom to create amazing art that
                            won't break the bank. So, if you're tired of uninspired cash grabs and are looking for something truly
                            special, come join us and see what true artistry looks like.</p>
                        <p>Our goal is to build a thriving community of like-minded individuals who share a passion for art,
                            storytelling, and innovation. We aim to provide a platform for our members to connect, engage,
                            and grow together, all while experiencing the unparalleled quality and creativity that our
                            projects have to offer.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default OurTeam;